<template>
  <div>
    <div class="white primary--text font-weight-black pt-4 pb-4 pl-8 pr-8 d-none d-md-flex align-center rounded-lg">
      <div class="info--usuario">USUARIO</div>
      <div class="info--rol">ROL</div>
      <div class="info--estatus">ESTATUS</div>
      <div class="info--fecha">CREADO</div>
      <div class="info--action text-center">ACCIONES</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UsersTableHead",
};
</script>

<style lang="scss" scoped>
.info--usuario {
  width: 25%;
}
.info--rol {
  width: 20%;
}
.info--estatus {
  width: 15%;
}
.info--fecha {
  width: 20%;
}
.info--action {
  width: 20%;
}
</style>
